import * as helper from "./helper";
import Wechat from "./wechat";
import AliLife from "./aliLife";

const { isWechat, isAlipay } = helper;

const dftOptions = {
  wxConfig: undefined,
  BMapAK: "SiTaGOGId1BPTpYs9GLcTZs4",
  useBMap: false
};

export default new (class Context {
  isWechat = isWechat;
  isAlipay = isAlipay;
  isReady = false;

  async init() {
    console.log("context初始化开始！\n检测环境中...");

    if (isWechat) {
      if (this.wechat) return;
      if (!this.$options.wxConfig) {
        console.log("缺少微信sdk配置参数");
        return;
      }
      await this.initWx();
    }

    if (isAlipay) {
      if (this.aliLife) return;
      await this.initAli();
    }
  }

  initWx() {
    this.wechat = new Wechat(this.$options.wxConfig);
  }

  initAli() {
    this.aliLife = new AliLife();
  }

  // 调用者实例化后，需要await该方法，保证对应组件初始化完成
  async ready(options) {
    this.$options = { ...dftOptions, ...options };
    await this.init();
    if (this.aliLife) return await this.aliLife.ready();
    if (this.wechat) return await this.wechat.ready();
  }

  // 定位能力
  async getLocation() {
    var result;
    if (this.wechat) {
      result = this.wechat.getLocation();
      if (result && result.success) {
        return result;
      }
    }
    if (this.aliLife) {
      result = this.aliLife.getLocation();
      if (result && result.success) {
        return result;
      }
    }
    return { success: false, message: "暂时无法获取地址" };
  }

  // 分享能力
  async shareMessage(data) {
    if (this.wechat) return this.wechat.shareMessage(data);
    return { success: false, message: "平台不支持" };
  }

  // 分享能力
  async shareTimeline(data) {
    if (this.wechat) return this.wechat.shareTimeline(data);
    return { success: false, message: "平台不支持" };
  }

  // 预览图片能力
  async previewImage(data) {
    if (this.wechat) return this.wechat.previewImage(data);
    if (this.aliLife) return this.aliLife.previewImage(data);
    return { success: false, message: "平台不支持" };
  }

  // 扫码能力
  async scanCode(data) {
    if (this.wechat) return this.wechat.scanCode(data);
    if (this.aliLife) return this.aliLife.scanCode(data);
    return { success: false, message: "平台不支持" };
  }
})();
